import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import { Link } from 'react-router'
import FindUser from './find-user'

let Home = ({ user, isAdmin, sendVerification }) => (
  <div className='container'>
    <div className='info'>
      <div className='row'>
        <h4>Logging in at the Democratic Alliance</h4>
      </div>
    </div>
    <div className='content'>
      <div className='container'>
        {
          user.sub || user && user.user && user.user.sub ?
            <div>
            <p>Hello { user.sub }. Please continue to <a href="https://start.voteda.org">our apps</a>.</p>
            </div> :
            <p>You are not logged in. Please <Link to="/login">Login Here</Link></p>
        }
        { isAdmin ? <FindUser /> : null }
      </div>
    </div>
  </div>
)

function mapStateToProps(state, ownProps) {
  const { user } = state
  return {
    user: user,
    isAdmin: user.isAdmin
  }
}

function mapDispatchToProps(dispatch) {
  return {
    sendVerification: bindActionCreators(actions.sendVerification, dispatch)
  }
}

Home = connect(mapStateToProps, mapDispatchToProps)(Home)

export default Home



// WEBPACK FOOTER //
// ./src/app/components/home.js